import { ErpApiKeyService } from "@common/client"
import { makeAxiosMutation, makeNoArgsQuery } from "./utils"

export const erpApiKeyKey = ["erp-api-key"] as const

export const erpApiKeyQuery = makeNoArgsQuery({
  serviceCall: ErpApiKeyService.getErpApiKey,
  queryKey: erpApiKeyKey,
})

export const useSetErpApiKeyMutation = makeAxiosMutation({
  serviceCall: ErpApiKeyService.setErpApiKey,
  invalidates: () => [erpApiKeyKey],
})

export const useClearErpApiKeyMutation = makeAxiosMutation({
  serviceCall: ErpApiKeyService.clearErpApiKey,
  invalidates: () => [erpApiKeyKey],
})
